<template>
    <div class="home-msg-list">
        <div class="date-search pb10 pr5 align-right">
            <el-date-picker style="width: 264px; margin-top: 2px;" v-model="timeScope" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <button class="swb-btn swb-btn-small" style="margin-top: -5px;" @click="getXMsgList()">搜索</button>
        </div>
        <div class="card-layout" style="">
            <el-tabs style="font-size: 13px" v-model="fieldx" type="card" @tab-click="getXMsgList()">
                <el-tab-pane :key="item.code" v-for="item in voucherTypes" :label="item.text" :name="item.code"></el-tab-pane>
            </el-tabs>
            <div class="message-list">
                <div class="message-item" v-for="xMsg in xMsgList">
                    <a class="content">
                        <span v-if="xMsg.notShowView">{{xMsg.txt}}</span>
                        <span v-else @click="msgInfo(xMsg)">{{xMsg.txt}}</span>
                    </a>
                    <span class="date">{{xMsg.sendTime.replace('.000', '')}}</span>
                </div>
            </div>
        </div>
        <div class="pagination-layout">
            <el-pagination :pager-count="5" small background :page-size="pageSize" :page-sizes="pageSizes" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total,sizes, prev, pager, next"></el-pagination>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import userApi from '../../api/user';

    export default {
        name: 'swb-home-msg-list',
        desc: '接收消息列表',
        props: {
            voucherTypeList: {
                type: Object,
            },
            fieldNamex: {
                type: String,
                default: null
            },
        },
        data: function () {
            return {
                xMsgList: [],
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                fieldx: null,
                source: null,
                txt: null,
                timeScope: null,
                //
                voucherTypes: [],
                sourceFlag: [],
                theLoad: null,
            }
        },
        created: function () {
            let self = this;
            this.pageSize = this.pageSizes.first();
            // 获取站内信的业务场景/来源
            this.voucherTypes = this.voucherTypeList;
            this.fieldx = this.fieldNamex;
            this.sourceFlag = getEnumList("sourceFlag");
            //
            new Utils.CondMonitor().when(function () {
                return MsgClient.isOpen();
            }).then(function () {
                self.getXMsgList();
            }).timeout(3000).start();

        },
        methods: {
            handleSizeChange(val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                //console.log("新页码：" + newPageNumber);
                this.handlePageChange(newPageNumber);
            },
            handlePageChange(val) {
                this.pageNumber = val;
                //
                this.getXMsgList();
            },
            getXMsgList: function () {
                let self = this;
                let pageSize = self.pageSize;
                let pageNumber = self.pageNumber;
                //
                let filterItems = {};
                if(!Utils.isNoB(self.fieldx) && self.fieldx != "null") {
                    filterItems.fieldx = self.fieldx;
                }
                if(!Utils.isNoB(self.source)) {
                    filterItems.source = self.source;
                }
                if(!Utils.isNoB(self.txt)) {
                    filterItems.txt = self.txt;
                }
                filterItems.readFlag = false;
                let timeScope = self.timeScope;
                if(!Utils.isNoB(timeScope)) {
                    let sendTimeFrom = timeScope[0];
                    let sendTimeTo = timeScope[1];
                    //
                    filterItems.sendTimeFrom = sendTimeFrom.format("yyyy-MM-dd");
                    filterItems.sendTimeTo = sendTimeTo.format("yyyy-MM-dd");
                }
                MsgClient.setMsgsForReceiverHandler(self.renderReceiverMsgList);
                MsgClient.fetchMsgsForReceiver(pageNumber, pageSize, filterItems);
            },
            renderReceiverMsgList: function (msgsResult) {
                let xMsgList = msgsResult.rows || [];
                for(let i = 0; i < xMsgList.length; i++) {
                    let msgInfo = xMsgList[i];
                    if(!Utils.isNoB(msgInfo.data) && msgInfo.data.indexOf('{') >= 0) {
                        let currentData = JSON.decode(msgInfo.data);
                        msgInfo.notShowView = Utils.isTrue(currentData.notShowView);    // 不显示【查看】
                    }
                }
                this.xMsgList = xMsgList;
                //结果应用
                let pagination = msgsResult.pagination;
                this.totalCount = pagination.totalCount;
                this.pageNumber = pagination.pageNumber;
                this.pageSize = pagination.pageSize;
            },
            // 当前分组（filedx）设置为全部已读
            markMsgGroupAsRead: function () {
                let fieldx = this.fieldx;
                if(fieldx == 'null') {
                    fieldx = null;
                }
                //
                MsgClient.markMsgGroupAsRead(null, fieldx);
                //
                this.getXMsgList();
            },
            msgInfo: function (row) {
                let self = this;
                MsgClient.markMsgAsRead(row.id);
                if(!Utils.isNoB(self.fieldx) && self.fieldx == 'notice') {
                    let noticeId = row.fieldy;
                    Vue.$showDialog({
                        title: "通知 - 查看",
                        width: 1200,
                        height: 750,
                        okVisible: false,
                        showCloseBtn: true,
                        okClicked: false,
                        cancelText: '关闭',
                        template: '<div>' +
                        '<swb-retailer-notice-view :id="id" :showTag="false" :noEditor="true" ref="swb_retailer_notice_view"></swb-retailer-notice-view>' +
                        '</div>',
                        data: {
                            id: noticeId,
                        }
                    });
                } else {
                    Vue.$showDialog({
                        title: '查看站内信',
                        showCloseBtn: true,
                        okVisible: false,
                        cancelText: '关闭',
                        height: 650,
                        template: '<div class="simple-form">' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>标题</label>' +
                        '</div>' +
                        '<div class="form-value flex">' +
                        '<label>{{txt}}</label>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-group center">' +
                        '<div class="form-label">' +
                        '<label>内容</label>' +
                        '</div>' +
                        '<div class="form-value flex" v-if="isJson">{{JSON.decode(jsonData).message}}</div>' +
                        '<div class="form-value flex" v-else>{{jsonData}}</div>' +
                        '</div>' +
                        '<div class="form-group center" v-if="type == 1">' +
                        '<div class="form-label">' +
                        '<label>图片</label>' +
                        '</div>' +
                        '<div class="form-value flex" v-if="url != null"><img style="width:200px; height: 200px;" :src="url"/></div>' +
                        '</div>' +
                        '</div>',
                        data: {
                            jsonData: row.data || '',
                            isJson: (row.data || '').startsWith('{') && (row.data || '').endsWith('}'),
                            txt: null,
                            type: row.type,
                            url: row.url,
                        },
                        methods: {},
                        okClicked: function () {
                        },
                        lifecycle: {
                            created: function () {
                                let selfDlg = this;
                                selfDlg.txt = row.txt;
                            }
                        }
                    });
                }
                self.getXMsgList();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/msg/homeMsgList.vue